import { IProjectTempStyles } from "@kuika/kuika-cl-model";

/**
 * Forgets every temp style section. A styleObj write (the styling panel's, the canvas selection bar's)
 * records the component's new section values in `projectTempStyles`, and the canvas renderer
 * (`StyleHelper.getTextStyles` and its siblings) and the panel's form loader lay them OVER the
 * component's own styleObj. They describe the write that set them; once undo or redo moves the screen
 * design to another point in history they are stale, and leaving them in place kept the undone Bold /
 * Underline on the canvas and fed it back into the panel's form, which saved it again.
 *
 * Reset in place: writers hold this object through the context snapshot (`sdCtx.projectTempStyles`) and
 * mutate it, and the canvas's render message reads it, so a replaced object would leave them on the old one.
 */
export function resetProjectTempStyles(projectTempStyles: IProjectTempStyles | undefined): void {
  if (!projectTempStyles) {
    return;
  }
  projectTempStyles.tempStylingTypography = undefined;
  projectTempStyles.tempStylingFill = undefined;
  projectTempStyles.tempStylingBorder = undefined;
  projectTempStyles.tempStylingShadow = undefined;
  projectTempStyles.tempStylingPosition = undefined;
  projectTempStyles.tempStylingEffects = undefined;
}
